import { useMemo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import {
  selectPromos,
  selectPromosDataState,
} from '../state/promos/promos.slice';

const usePromos = () => {
  const promos = useSelector(selectPromos);
  const promosDataState = useSelector(selectPromosDataState);
  const returnObj = useMemo(
    () => ({
      promos,
      promosDataState,
    }),
    [promos, promosDataState],
  );

  return returnObj;
};

export default usePromos;
